import React from 'react';
import PageHero from '@/components/PageHero';
import SEO from '@/components/SEO';
import { PROGRAM } from '@/data/content';
import { CheckCircle2 } from 'lucide-react';

export default function Program() {
  return (
    <div>
      <SEO
        title="The Program"
        description="Drug and Alcohol Awareness: The Value of Making the Right Choices — a 90-minute in-person school presentation for grades 6-12 featuring law enforcement and real-life stories."
        path="/program"
      />
      <PageHero
        title={PROGRAM.headline}
        subtitle="An educational program for grades 6–12 delivered by decorated law enforcement and real-life storytellers."
        image="https://images.unsplash.com/photo-1571260899304-425eee4c7efc?auto=format&fit=crop&w=1920&q=80"
        crumbs={['Program']}
      />
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="prose prose-slate max-w-none">
          {PROGRAM.paragraphs.map((p, i) => (
            <p key={i} className="text-slate-700 leading-[1.9] text-[15.5px] mb-6">{p}</p>
          ))}
        </div>

        <div className="mt-12 p-8 bg-[#0b2545] text-white rounded-lg">
          <div className="text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold mb-3">Take Away</div>
          <h3 className="font-serif text-2xl font-bold mb-6">What Every School Receives</h3>
          <ul className="space-y-3">
            {[
              'A nine-class curriculum manual',
              'An over 1-hour video presentation for grades 6–12',
              'Student handouts',
              'Real-life stories from a decorated police lieutenant and an incarcerated individual',
              'Factual coverage of common drugs of choice and their consequences',
              'Q&A time with students following the presentation',
              '"Make the Right Choice Today" reminder sign installed on school property',
            ].map((t, i) => (
              <li key={i} className="flex items-start gap-3">
                <CheckCircle2 className="h-5 w-5 text-amber-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-200">{t}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
